import { CheckerCheck } from '../checker.model';

export type GithubGlobalCheckId = 'status';

export interface GithubGlobalCheckerCheck extends CheckerCheck {
  id: GithubGlobalCheckId;
}

export const statusEmoji: Record<string, string> = {
  partial_outage: '🟡',
  major_outage: '🔴',
};

export interface GithubStatusSummaryResponse {
  page: {
    updated_at: string;
  };
  status: {
    indicator: string; // sample: 'none'
    description: string; // sample: 'All Systems Operational'
  };
  components: {
    id: string; // sample: '8l4ygp009s5s';
    name: string; // sample: 'Git Operations';
    status: string; // sample: 'operational';
    updated_at: string; // sample: '2024-03-12T00:55:20.988Z';
    position: number; // sample: 1;
    description: string; // sample: 'Performance of git clones, pulls, pushes, and associated operations';
  }[];
}
